var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { wrap: "", "mx-1": "" } },
    [
      _c(
        "v-flex",
        { staticClass: "form-section", attrs: { xs12: "", md6: "" } },
        [
          _c(
            "v-flex",
            { attrs: { "mb-3": "" } },
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("1")]),
                _vm._v(" "),
                _c("div", { staticClass: "red--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text " }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.bmContact)))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            {
              attrs: {
                required: "",
                label: _vm.lblSetting.bmMeetingParticipant
              }
            },
            [
              _c("base-multi-select", {
                key: 1,
                attrs: {
                  rules: _vm.dtRules.participantRules,
                  options: _vm.coParticipants,
                  disabled: _vm.toUpdate,
                  loading: _vm.dtLoadingParticipant,
                  "return-object": false,
                  multiple: false,
                  "hide-details": true,
                  fetch: _vm.handleGetDeclarants,
                  "item-value": "id"
                },
                on: { change: _vm.handleChangeParticipant },
                model: {
                  value: _vm.Participant,
                  callback: function($$v) {
                    _vm.Participant = $$v
                  },
                  expression: "Participant"
                }
              }),
              _vm._v(" "),
              !_vm.toUpdate
                ? _c("v-switch", {
                    staticClass: "ml-1",
                    attrs: {
                      label: _vm.$t(_vm.lblSetting.bmSearchAllContact),
                      color: "primary"
                    },
                    on: { change: _vm.changeSwitchSearch },
                    model: {
                      value: _vm.dtSearchAll,
                      callback: function($$v) {
                        _vm.dtSearchAll = $$v
                      },
                      expression: "dtSearchAll"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "form-section",
          attrs: { "pl-3": "", xs12: "", md6: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { "mb-3": "" } },
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("2")]),
                _vm._v(" "),
                _c("div", { staticClass: "red--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text" }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.bmPresence)))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            {
              attrs: {
                required: "",
                xs4: "",
                label: "" + _vm.$t(_vm.lblSetting.bmMeetingPresence)
              }
            },
            [
              _c(
                "v-radio-group",
                {
                  staticClass: "mx-3 mt-0",
                  attrs: { row: "", "hide-details": "" },
                  model: {
                    value: _vm.Presence,
                    callback: function($$v) {
                      _vm.Presence = $$v
                    },
                    expression: "Presence"
                  }
                },
                [
                  _c("v-radio", {
                    attrs: {
                      label: _vm.$t(_vm.lblSetting.bmMeetingPresent),
                      color: "primary",
                      value: "P"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-radio", {
                    attrs: {
                      label: _vm.$t(_vm.lblSetting.bmMeetingAbsent),
                      color: "primary",
                      value: "A"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-radio", {
                    attrs: {
                      label: _vm.$t(_vm.lblSetting.bmMeetingCantBeHere),
                      color: "primary",
                      value: "E"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("v-switch", {
                staticClass: "ml-1",
                attrs: {
                  label: _vm.$t(_vm.lblSetting.bmSummonNextMeeting),
                  color: "primary"
                },
                model: {
                  value: _vm.Summon,
                  callback: function($$v) {
                    _vm.Summon = $$v
                  },
                  expression: "Summon"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-deefa0da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-deefa0da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/building-monitor/components/bm-participant-modal-vertical/template.html
// module id = null
// module chunks = 